const apiProxy: { [key: string]: string } = {
  "localhost:3001": "https://api-dev.inctrl.ai",
  "chat-dev.inctrl.ai": "https://api-dev.inctrl.ai",
  "chat-stage.inctrl.ai": "https://api.stage.inctrl.ai",
  "chat.inctrl.ai": "https://api.inctrl.ai",
};

export const getBaseUrl = () => apiProxy[window.location.host];
